// Billing commands whose outcome a mounted page reports to the merchant itself,
// so the app-wide websocket handler stays quiet about them. A claim outlives
// the page's own handling of the outcome: the page and the app-wide handler
// read separate sockets, and either may see the terminal push first.
const claimedCommandIds = new Set<string>();

export const claimBillingCommandFeedback = (commandId: string): void => {
  claimedCommandIds.add(commandId);
};

export const releaseBillingCommandFeedback = (commandId: string): void => {
  claimedCommandIds.delete(commandId);
};

export const isBillingCommandFeedbackClaimed = (commandId: string): boolean =>
  claimedCommandIds.has(commandId);
